export default "__VITE_ASSET__DNenF8J$__"